import * as Linking from 'expo-linking';
import { buildNativeAppDeepLink } from '@/lib/auth/native-app-deep-link';
import api from '@/services/api';
import { useAuthStore } from '@/store/authStore';

export const APP_HANDOFF_PARAM = 'handoff';

export function parseHandoffTokenFromUrl(url: string): string | null {
  const fromRegex = url.match(/[?&]handoff=([^&]+)/)?.[1];
  if (fromRegex) {
    try {
      return decodeURIComponent(fromRegex);
    } catch {
      return fromRegex;
    }
  }

  try {
    const parsed = Linking.parse(url);
    const value = parsed.queryParams?.[APP_HANDOFF_PARAM];
    if (typeof value === 'string' && value.length > 0) return value;
    if (Array.isArray(value) && typeof value[0] === 'string') return value[0];
  } catch {
    // ignore
  }
  return null;
}

export function isAppHandoffCallbackUrl(url: string): boolean {
  return parseHandoffTokenFromUrl(url) != null;
}

export function getNativeCallbackWithHandoffUrl(handoffToken: string): string {
  return buildNativeAppDeepLink('auth/callback', {
    [APP_HANDOFF_PARAM]: handoffToken,
  });
}

export async function requestAppHandoffToken(): Promise<string | null> {
  const token = useAuthStore.getState().token;
  if (!token) return null;
  try {
    const res = await api.post<{ handoffToken: string }>('/auth/app-handoff');
    return res.data.handoffToken ?? null;
  } catch (err) {
    if (__DEV__) {
      console.warn('[app-handoff] POST /auth/app-handoff failed:', err);
    }
    return null;
  }
}
